import { ProductModule } from '@erp/shared-types';

/**
 * Urgency levels for tasks
 */
export type TaskUrgency = 'urgent' | 'high' | 'normal' | 'low';

/**
 * Task definition - declarative configuration for a task type
 */
export interface TaskDefinition {
  /** Unique identifier for this task type */
  id: string;
  /** Function to generate the display title with count interpolation */
  getTitle: (count: number) => string;
  /** Visual urgency level */
  urgency: TaskUrgency;
  /** Target path for navigation when clicked */
  targetPath: string;
  /** Search params to add to the URL when navigating */
  searchParams: Record<string, string | string[]>;
  /** Required module(s) - task is hidden if user doesn't have access */
  requiredModule?: ProductModule;
}

/**
 * Runtime task instance - a task definition combined with its count
 */
export interface Task {
  /** Task definition ID */
  id: string;
  /** Display title with count */
  title: string;
  /** Visual urgency level */
  urgency: TaskUrgency;
  /** Current count */
  count: number;
  /** Target path for navigation */
  targetPath: string;
  /** Search params to add to the URL */
  searchParams: Record<string, string | string[]>;
}

/**
 * Static task - a hardcoded task item (for demo/placeholder purposes)
 */
export interface StaticTask {
  id: string;
  title: string;
  urgency: TaskUrgency;
  done: boolean;
  /** Optional path for navigation when clicked */
  targetPath?: string;
}

/**
 * Urgency to sort order mapping
 */
export const URGENCY_ORDER: Record<TaskUrgency, number> = {
  urgent: 0,
  high: 1,
  normal: 2,
  low: 3,
};

/**
 * Urgency to color mapping
 */
export const URGENCY_COLORS: Record<TaskUrgency, string> = {
  urgent: 'bg-red-500',
  high: 'bg-orange-500',
  normal: 'bg-blue-500',
  low: 'bg-gray-400',
};
